<mat-button-toggle-group name="fontStyle" [value]="type" (change)="onTypeChange($event.value)" aria-label="Font Style">
    <mat-button-toggle *ngIf="hasProperty" value="property">Property</mat-button-toggle>
    <mat-button-toggle *ngIf="hasTag" value="tag">Tag</mat-button-toggle>
</mat-button-toggle-group>